//libs
import VueMeta from 'vue-meta'
import Vuesax from 'vuesax'
import VueProgressBar from 'vue-progressbar'
import { VueHammer } from 'vue2-hammer'
import VueCodeHighlight from 'vue-code-highlight'
import VTooltip from 'v-tooltip'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'prismjs'

import VueHighlightJS from "vue-highlight.js"
import "highlight.js/styles/github-dark.css" // github-dark.css

import javascript from "highlight.js/lib/languages/javascript"
import php from "highlight.js/lib/languages/php"
import json from "highlight.js/lib/languages/json"
import go from "highlight.js/lib/languages/go"

import urlPlugin from './plugins/url'
import can from './directives/can'

//components
import Popup from './components/popup/Popup'
import NoData from './components/NoData.vue'
import errors from './plugins/backendErrors'
import Loader from './components/Loader.vue'
import FilterFields from './components/filters/Filter.vue'
import DatePicker from '@/components/date-picker/Picker'
import VDatePicker from '@/components/date-picker/VDatePicker.vue'
import Table from './components/custom-table/Table'
import VSTable from "@/components/custom-table/VSTable"
import SNTable from './components/custom-table/SNTable'
import GlobalPopup from './components/popup/GlobalPopup'
import DSTable from './components/table/Table'
import PasswordInput from './components/inputs/Password'
import Flags from './components/flags/Flags'
import DsFilter from './components/table/Filter'
import Tabs from './components/tabs/Tabs'

import { dateFilter, timeFilter } from "./filters/date"

import './axios.js'
import './filters/filters.js'
import '../themeConfig.js'
import './globalComponents.js'

//plugins
import generator from './plugins/passwordGenerator'
import icons from "@/plugins/icons";

//styles
import './assets/fonts/uicons/css/all/all.css'
import 'material-icons/iconfont/material-icons.css'
import 'vuesax/dist/vuesax.css'
import "vue-code-highlight/themes/duotone-sea.css"
import "vue-code-highlight/themes/window.css"
import 'prismjs/themes/prism-tomorrow.css'

import './assets/scss/main.scss'
import './assets/css/main.css'
import './assets/css/iconfont.css'
import './assets/css/fonts.css'

export default Vue => {
    return {
        use: () => {
            Vue.use(VueMeta)
            Vue.use(Vuesax)
            Vue.use(VueProgressBar, { color: '#5186bb', failedColor: 'red', height: '2px'})
            Vue.use(VueHammer)
            Vue.use(urlPlugin)
            Vue.use(errors)
            Vue.use(VueCodeHighlight)
            Vue.use(VTooltip)
            Vue.use(VueHighlightJS, {
                languages: {
                    javascript,
                    php,
                    json,
                    go
                }
            })
            Vue.use(generator)
            Vue.use(icons)
        },
        components: () => {
            Vue.component('popup', Popup)
            Vue.component('ValidationProvider', ValidationProvider)
            Vue.component('ValidationObserver', ValidationObserver)
            Vue.component('no-data', NoData)
            Vue.component('c-loader', Loader)
            Vue.component('filter-fields', FilterFields)
            Vue.component('date-picker', DatePicker)
            Vue.component('v-date-picker', VDatePicker)
            Vue.component('vc-table', Table)
            Vue.component('vst-table', VSTable)
            Vue.component('vc-sn-table', SNTable)
            Vue.component('vc-popup', GlobalPopup)
            Vue.component('ds-table', DSTable)
            Vue.component('password-input', PasswordInput)
            Vue.component('flag', Flags)
            Vue.component('ds-filter', DsFilter)
            Vue.component('tabs', Tabs)
        },
        filters: () => {
            Vue.filter('date', dateFilter)
            Vue.filter('time', timeFilter)
        },
        directives: () => {
            Vue.directive('can', can)
        }
    }
}
